import React, {useEffect, useMemo, useRef, useState} from 'react';
import {connect} from "react-redux";
import { List } from 'react-virtualized';
import 'react-virtualized/styles.css';
import {injectIntl} from "react-intl";

import {
  SIDEBAR_NAVIGATION_BUTTONS, SQFT_APPLIANCES,
  SQFT_APPLIANCES_WITH_SUBMENU, SQFT_FEATURES
} from "../../../../constants";
import {setSelectedCountertop, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import SqftNavFeaturesRow from "./SqftNavFeaturesRow";
import {getCurrentLayout} from "../../../../../appLayout";
import {checkIfLookFeaturesReceived} from "../../../../../../api/look-api";
import {getFeatureGroupName} from "../../../../../../misc/helpers";
import LoadingSpinner from "../../../../../ui/loadingSpinner";

const SqftNavFeatures = (props) => {
  const {setSQFTActiveButton, setSQFTMenuOpened} = props;
  const {menuOpened, isMobile, fabricatorData, intl, selectedCountertop, windowHeight} = props;
  const expanded = SQFT_APPLIANCES_WITH_SUBMENU.includes(menuOpened); // this can be used not only for the appliance sub items
   // || menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland;
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [activeItemIndex, setActiveItemIndex] = React.useState(0);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [listWidth, setListWidth] = useState(296);

  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight);
    }
  }, [windowHeight]);

  useEffect(() => {
    setListWidth(isMobile ? 238 : 296);
  }, [isMobile]);

  useEffect(() => {
    const fetchRows = async () => {
      if (menuOpened && featureGroup) {
        setIsLoading(true);
        if (featureGroup && !featureGroup.allFeaturesReceived) {
          await checkIfLookFeaturesReceived(featureGroup);
        }
        const navItems = layout.designNavigationItems(
          { part: featureGroup },
          [],
          "",
          featureGroup.activeFeature,
          "all",
          [],
          { firstFeature: null, firstConditions: null },
        );

        const filteredNavItems = navItems.filter(navItem => navItem.part.dbFeature.thirdPartyAR3DUrls);
        setRows(filteredNavItems);
        setIsLoading(false);
      }
    };

    fetchRows().then(r => {void r});
  }, [layout, featureGroup, menuOpened]);

  const handleClose = () => {
    setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.move);
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
  }

  const layout = useMemo(() => getCurrentLayout(), []);
  const featureGroup = useMemo(() => {
    if (menuOpened) {
      let partId = menuOpened;
      if (menuOpened === SQFT_APPLIANCES.refrigerator) {
        partId = 'fridge'
      } else if (menuOpened === SQFT_APPLIANCES.stovetop) {
        partId = 'stove'
      }
      const featureGroup = layout.getFeatureGroupByPartId(partId)

      //set countertop to default
      void SQFT_FEATURES
      void selectedCountertop
      void setSelectedCountertop
      // if (featureGroup.partId === SQFT_FEATURES.countertop && !selectedCountertop) {
      //   setSelectedCountertop(featureGroup.activeFeature.dbFeature.id)
      // }

      return featureGroup
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout, menuOpened]);
  const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);

  return (
    <div className={"content content-features side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <div className="side-level2__title summary-main-title">
          <div className="summary-main-text">
            {featureGroupName}
          </div>
          <button className="button--close"
                  onClick={handleClose}
          />
        </div>
        <div className="side-level2__content" ref={containerRef}>
          { isLoading
            ? <LoadingSpinner/>
            : <List
              width={listWidth}
              height={containerHeight}
              rowCount={rows.length}
              rowHeight={135}
              rowRenderer={({ key, index, style }) => (
                <SqftNavFeaturesRow
                  key={key}
                  style={style}
                  feature={rows[index]}
                  featureGroup={featureGroup}
                  isActiveItem={activeItemIndex === index}
                  index={index}
                  setActiveItemIndex={setActiveItemIndex}
                />
              )}
            />
          }
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {isMobile, windowHeight} = store.serverState;
  return {
    menuOpened,
    isMobile,
    windowHeight,
    fabricatorData: store.fabricatorState,
    selectedCountertop: store.sqftState.selectedCountertop
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavFeatures)
)
